import { RootState } from 'store';

export const WorkSitesLookupState = (state: RootState) => state.lookups.workSites;
export const selectWorkSites = (state: RootState) => WorkSitesLookupState(state).rows;
